import React from 'react'
import styled from 'styled-components'
import mixins from 'utils/mixins'

const NumDisplay = styled.div`
  ${mixins.bigNum}
  margin-bottom: 20px;
`
export default ({ bigNum, heading, className, style }) => (
  <NumDisplay className={className} style={style}>
    <span className="big-num">{bigNum}</span>
    <span>{heading.toUpperCase()}</span>
  </NumDisplay>
)